// this function is used to format the number based on the contry currency code
export const numberFormat = (number, lang, showZero, classNameCurrency, displayCurrencyLiter = true, syntax = { code: 'SAR', locale: 'en' }) => {
    if (number == null || number === undefined || number === 'null' || number === '' || ((number === '0' || number === 0) && showZero === false)) {
        return null;
    }

    const formattedNumber = new Intl.NumberFormat('en-US').format(number);

    if (displayCurrencyLiter) {
        return (classNameCurrency ?
            <span key={Math.random} className={classNameCurrency}>
                {<CurrencyCode number={formattedNumber} />}
            </span> : <CurrencyCode number={formattedNumber} />)
    }
    return formattedNumber;
};


export const CurrencyCode = ({ number }) => {
    return (
        (<i className="icon-icomoon-Saudi_Riyal_Symbol-2" >{number}</i>)
    );
};
